export const isValidIPv4 = (ip) => {
  const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
  return ipv4Regex.test(ip)
}

export const isValidIPv4WithSubnet = (ipWithSubnet) => {
  const subnetRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[12]?[0-9])$/
  return subnetRegex.test(ipWithSubnet)
}

export const isValidIPv4OrSubnet = (value) => {
  if (!value) return false

  if (value.includes('/')) {
    return isValidIPv4WithSubnet(value)
  } else {
    return isValidIPv4(value)
  }
}

// Mirrors the backend validate_ip_or_fqdn regex: dotted labels + an alpha TLD.
export const isValidFqdn = (value) => {
  const fqdnRegex = /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i
  return fqdnRegex.test(value)
}

export const isValidIPv6 = (value) => {
  if (!value || !value.includes(':')) return false
  try {
    const parsed = new URL(`http://[${value}]`)
    return !!parsed.hostname
  } catch {
    return false
  }
}

export const isValidIpOrFqdn = (value) => {
  if (!value) return false
  return isValidIPv4(value) || isValidIPv6(value) || isValidFqdn(value)
}

export const isValidUrl = (value) => {
  try {
    const url = new URL(value)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
    const host = url.hostname
    if (host === 'localhost') return true
    if (host.startsWith('[') && host.endsWith(']')) return isValidIPv6(host.slice(1, -1))
    return isValidIpOrFqdn(host)
  } catch {
    return false
  }
}
